import { Loader } from "../common/components";
import { useState } from "react";

export const REACT_APP_MAPS_PATH = process.env.REACT_APP_MAPS_PATH as string || `http://localhost:${process.env.REACT_APP_MAPS_PORT || 8080}`;

export const ProjectMap= ({ id }) => {
    const [isLoaded, setLoaded] = useState(false);
    return <div className="bgTab">
        {!isLoaded && <Loader />}
        <iframe
    src={`${REACT_APP_MAPS_PATH}/#/map/${id}`}
    className="map"
    style={{ display: isLoaded ? "block" : "none" }}
    title="resources.project.map.title"
    onLoad={() => {setLoaded(true)}}
></iframe></div>
};